import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHome, faArchive, faUser } from "@fortawesome/free-solid-svg-icons";
import "../commons/NavbarTechnician.css";
import { NavLink } from "react-router-dom";

class NavbarTechnician extends React.Component {
  render() {
    return (
      <React.Fragment>
        <nav
          id="navbarTec"
          className="navbar navbar-expand-lg navbar-dark bg-dark fixed-bottom"
        >
          <div className="container text-center navbInferior">
            <div className="home">
              <NavLink to="/homeTechnician">
                <span className="iconSizeNav">
                  <FontAwesomeIcon icon={faHome} />
                </span>
                <span style={{ display: "block" }}> Home</span>
              </NavLink>
            </div>
            <div className="job">
              <NavLink to="/request_available">
                <span className="iconSizeNav">
                  <FontAwesomeIcon icon={faArchive} />
                </span>
                <span style={{ display: "block" }}>Job</span>
              </NavLink>
            </div>
            <div className="profile">
              <NavLink to="/profile">
                <span className="iconSizeNav">
                  <FontAwesomeIcon icon={faUser} />
                </span>
                <span style={{ display: "block" }}>Profile</span>
              </NavLink>
            </div>
          </div>
        </nav>
      </React.Fragment>
    );
  }
}
export default NavbarTechnician;
